export default __webpack_public_path__ + "static/media/Burger-menu.3fca2e5a.svg";